import "../SignIn/SignIn.css";
import { Image, Container, Col, Row, Button, div } from "react-bootstrap";
import Logo from "../../assets/communityXlogo.svg";
import signupimg from "../../assets/signup.png";
import "react-step-progress/dist/index.css";
import GeneralInfo from "../GeneralInfo/GeneralInfo";
import BusinessInfo from "../BusinessInfo/BusinessInfo";
import Acknowledgement from "../Acknowledgement/Acknowledgement";
import { useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Loader from "../../Components/Loader/Loader";

const SignUp = () => {
  // const { costHistory } = useSelector((state) => state);
  const [key, setKey] = useState("step1");
  const [cityId, setCityId] = useState(0);
  const [selectTabGeneralInfo, setSelectTabGeneralInfo] = useState(0);
  const [selectTabBusinessInfo, setSelectTabBusinessInfo] = useState(0);
  const [selectTabAcknowledge, setSelectTabAcknowledge] = useState(0);
  const [loading, setLoading] = useState(false);

  const [businessInfoData, setBusinessInfoData] = useState({});
  const [generalInfoData, setGeneralInfoData] = useState({});

  const FetchCityId = (id) => {
    setCityId(id);
  };

  const GeneralInfoNextBtn = (val) => {
    setSelectTabGeneralInfo(val);
    if (val === 1) {
      setKey("step2");
    }
  };

  const AcknowledgementPrevBtn = (val) => {
    if (val === 1) {
      setKey("step2");
    }
  };

  const BusinessInfoNextPrevBtn = (val1, val2) => {
    setSelectTabBusinessInfo(val1);
    if (val1 === 1) {
      setKey("step3");
    }
    if (val2 === 1) {
      setKey("step1");
    }
  };

  const AcknowledgementFlag = (val) => {
    setSelectTabAcknowledge(val);
  };

  const onSelectTabs = (k) => {
    // if (k === "step1" && selectTabGeneralInfo === 1) {
    //   setKey("step1");
    // }
    // if (k === "step2" && selectTabGeneralInfo === 1) {
    //   setKey("step2");
    // }
    // if (k === "step2" && selectTabBusinessInfo === 1) {
    //   setKey("step2");
    // }
    // if (k === "step3" && selectTabAcknowledge === 1) {
    //   setKey("step3");
    // }
    // setKey(k);
    // GeneralInfoNextBtn();
  };

  const GeneralInfoFlagandData = (data) => {
    setGeneralInfoData(data);
  };

  const BusinessInfoFlagandData = (data) => {
    setBusinessInfoData(data);
  };

  return (
    <>
      {loading === true ? <Loader /> : <></>}
      <div className="main">
        <Container>
          <Row className="justify-content-md-center py-3">
            <Col xs lg="6" className="page-content-left">
              <Image
                loading="lazy"
                src={signupimg}
                width="100%"
                className="mt-5 pt-5"
              ></Image>
              <p className="login-text1 mt-4">
                Unlock the Power of Online Promotions!
              </p>
              <p className="login-text2 mt-2">
                Boost your sales and increase customer loyalty with our
                easy-to-use coupon platform. Reach thousands of potential
                customers and increase your bottom line. Sign up now!
              </p>
              <p className="login-text2 mt-3">
                The business account on CommunityX Digital is a freemium account
                with 1 voucher and 1 coupon for FREE.
              </p>
              <p className="text-xs mt-3 lineHeight-18">
                However, please note that fees may apply based on the specific
                CommunityX Digital Marketplace you choose to join.
              </p>
               <p className="login-text1 mt-4">Shop Local Digital is  now CommunityX Digital!</p>
            </Col>
            <Col
              md="6"
              className="page-content-right page-content-right-fullwidth"
            >
              {/* {show ==true ? <Validate/> : null} */}
              <div className="text-center mt-5 mb-2">
                <Image loading="lazy" src={Logo} className="logo_Image"></Image>
                <h1 className="sign-second mt-4 pt-0">Business User Sign Up</h1>
              </div>
              <Tabs
                activeKey={key}
                onSelect={onSelectTabs}
                id="uncontrolled-tab-example"
                className="mb-3 step-form"
              >
                <Tab eventKey="step1" title="1. GENERAL INFO">
                  <GeneralInfo
                    NextStep={GeneralInfoNextBtn}
                    GrData={GeneralInfoFlagandData}
                    city_id={FetchCityId}
                    // selectTabs={onSelectTabs}
                  />
                </Tab>
                <Tab eventKey="step2" title="2. BUSINESS INFO">
                  <BusinessInfo
                    NextPrevBtn={BusinessInfoNextPrevBtn}
                    BuData={BusinessInfoFlagandData}
                    city_id={cityId}
                  />
                </Tab>
                <Tab eventKey="step3" title="3. ACKNOWLEDGEMENT">
                  <Acknowledgement
                    PrevBtn={AcknowledgementPrevBtn}
                    BusinessInfoData={businessInfoData}
                    GeneralInfoData={generalInfoData}
                    tab_select={AcknowledgementFlag}
                    SetLoadingfuc={setLoading}
                  />
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
export default SignUp;
